<template>
  <el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
      <navigator />
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
      <div class="cs-fullHeight cs-contentContainer-right">
        <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
          <el-row>
            <el-col>
              <breadcrumbNavigationBar :data="breadcrumbNavigationBarData"></breadcrumbNavigationBar>
            </el-col>
          </el-row>
          <el-row>
            <el-col>&nbsp;</el-col>
          </el-row>
          <div v-loading="isLoadingWorkflowService">
            <el-row type="flex" class="workflowService-container">
              <el-col :span="16">
                <workflowServiceInfo :options="workflowServiceInfoOptions" :dataIn="workflowServiceInfoDataIn" />
              </el-col>
              <el-col v-if="!readonly" :span="8" class="action-container">
                <el-button v-if="showBtnCloseSAWorkflowService" type="primary" @click="onCloseSAWorkflowServiceClick">关闭服务</el-button>
              </el-col>
            </el-row>
            <el-divider />
            <el-row class="grid-content">
              <serviceItemList :studentInfo="student" :currency="workflowService.WorkflowCurrency" :readonly="readonly" :data="workflowService.ServiceItemList"
                @change="onServiceItemListChange" />
            </el-row>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import global_ from "@/core/global";
import { ObjectEx } from "vue-objectex";

import { getStudent } from "@/service/student.service";
import {
  getSAStudentWorkflowService,
  closeSAWorkflowServiceById,
} from "@/service/studyAbroad.service";
import { uncompileStr } from "@/config/mUtils";

const defaultWorkflowService = {
  WorkflowCurrency: global_.currencyType.CNY,
  ServiceItemList: [],
};

const mixin_bnBar = {
  components: {
    breadcrumbNavigationBar: () =>
      import("@/components/common/breadcrumbNavigationBar"),
  },
  data() {
    return {
      navName: "真留服务列表",
      breadcrumbNavigationBarData: new ObjectEx(
        [
          {
            key: "name",
            value: "真留",
          },
          {
            key: "currentName",
            value: "真留服务明细",
          },
          {
            key: "navList",
            value: [
              {
                basePath: "/studyAbroad/studentList",
                link: "/studyAbroad/studentList",
                name: "真留学员列表",
              },
              {
                basePath: "/studyAbroad/studentServiceList",
                link: `/studyAbroad/studentServiceList`,
                name: "真留服务列表",
              },
            ],
          },
        ],
        {
          updateNavList(newNavList) {
            this.navList = newNavList;
          },
        }
      ),
    };
  },
  created() {
    this.$nextTick(() => {
      if (!!this.$route.meta.navName) {
        this.navName = this.$route.meta.navName;
        this.breadcrumbNavigationBarData.updateCurrentName(this.navName);
      }
      this.updateNavListByRoute();
    });
  },
  methods: {
    updateNavListByRoute() {
      let navList = [];
      try {
        navList = this.$cryptoJS.enc.Base64.decode(this.routeQuery.navList);
        navList = JSON.parse(navList);
      } catch (error) {}
      if (Object.typeOf(navList) !== "array") return;

      let bnbNavList = [];
      navList.forEach((nav) => {
        let name;
        let route = this.$router.options.getRouteByPath(nav.path);
        if (!!route && !!route.meta.navName) name = route.meta.navName;
        switch (nav.path) {
          case "/studyAbroad/studentList":
            name = "真留学员列表";
            break;
          case "/studyAbroad/studentServiceList":
            name = "真留服务列表";
            break;
          case "/saServiceList":
            name = "真留计划项目";
            break;
        }

        if (!!name) {
          if (bnbNavList.length === 0) this.$route.meta.menuActive = nav.path;
          bnbNavList.push({
            basePath: nav.path,
            link: nav.path,
            name,
            data: nav.data,
          });
        }
      });
      this.breadcrumbNavigationBarData.updateNavList(bnbNavList);
    },
  },
};

export default {
  name: "studentServiceDetail",
  mixins: [mixin_bnBar],
  components: {
    navigator: () => import("@/components/navigator"),
    breadcrumbNavigationBar: () =>
      import("@/components/common/breadcrumbNavigationBar"),
    workflowServiceInfo: () =>
      import("@/components/studyAbroad/workflowServiceInfo"),
    serviceItemList: () =>
      import("@/components/studyAbroad/serviceItem/serviceItemList"),
  },
  data() {
    return {
      readonly: this.USERMANAGER.isSAAssistant || this.USERMANAGER.isStudent,
      routeQuery: {},
      student: {},
      workflowService: Object.clone(defaultWorkflowService),
      isLoadingWorkflowService: false,
      workflowServiceInfoOptions: {
        showTitle: true,
      },
      workflowServiceInfoDataIn: {
        workflowServiceId: 0,
        workflowServiceData: null,
      },
    };
  },
  created() {
    let paras = this.$route.query;
    let studentId = parseInt(uncompileStr(paras.studentId));
    let wsId = "";
    if (paras.wsId){
      wsId = parseInt(uncompileStr(paras.wsId));
    } 
    this.routeQuery = {
      studentId: studentId,
      wsId: wsId,
      navList: paras.navList
    };
    this.$nextTick(async () => {
      await this.loadStudentFromServer();
      await this.loadSAStudentWorkflowServiceFromServer();

      this.breadcrumbNavigationBarData.currentName =
        this.workflowService.ServiceName || "真留服务明细";
    });
  },
  computed: {
    showBtnCloseSAWorkflowService() {
      let count = this.workflowService.ServiceItemList.filter(
        (item) =>
          item.Status !== this.GLOBAL.enumStudyAbroadStatus.Closed &&
          item.Status !== this.GLOBAL.enumStudyAbroadStatus.Refund
      ).length;
      return count > 0;
    },
  },
  methods: {
    // 从服务端获取数据相关方法
    async loadStudentFromServer() {
      if (!this.routeQuery.studentId) return;
      let result = await getStudent(this.routeQuery.studentId);
      this.student =
        !!result && result.success && !!result.data ? result.data : {};
    },
    async loadSAStudentWorkflowServiceFromServer() {
      if (!this.routeQuery.wsId) return;
      this.isLoadingWorkflowService = true;

      try {
        let result = await getSAStudentWorkflowService(this.routeQuery.wsId);
        if (!!result && result.success) {
          this.workflowService = result.data;
        }else{
          if (result.message){
            this.$message.error(result.message);
          }
        }
      } catch (error) {}

      this.isLoadingWorkflowService = false;
    },
    async closeSAWorkflowServiceByIdToServer(closeDate) {
      let result = await closeSAWorkflowServiceById(
        this.workflowService.Id,
        closeDate
      );
      if (!result || !result.success) {
        this.$message.error(result.message);
        return false;
      }

      this.$message({
        message: "结束服务成功",
        type: "success",
      });

      this.onServiceItemListChange(true);

      return true;
    },

    // workflowServiceInfo 相关方法
    resetWorkflowServiceInfoDataIn() {
      let workflowServiceData =
        !!this.workflowService && !!this.workflowService.Id
          ? this.workflowService
          : null;

      this.workflowServiceInfoDataIn = {
        workflowServiceId: !!workflowServiceData
          ? workflowServiceData.Id
          : this.routeQuery.wsId,
        workflowServiceData: workflowServiceData,
      };
    },
    resetWorkflowServiceByServiceItems() {
      let newWorkflowService = Object.clone(this.workflowService);
      newWorkflowService.CostAmountAvailable =
        this.workflowService.ServiceItemList.sum(
          (item) => item.CostAmountAvailable
        );
      newWorkflowService.SaleAmountAvailable =
        this.workflowService.ServiceItemList.sum(
          (item) => item.SaleAmountAvailable
        );
      this.workflowService = newWorkflowService;
    },
    onCloseSAWorkflowServiceClick() {
      let closeDate = this.$moment().toDate();
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        message: h("div", null, [
          h(
            "div",
            null,
            `您确定要关闭该服务${
              !!this.workflowService.ServiceName
                ? " - " + this.workflowService.ServiceName
                : String.empty
            }及其下所有小项吗?`
          ),
          h("div", null, [
            h("span", null, "关闭日期："),
            h("msg-date-picker", {
              props: {
                size: "small",
                format: "yyyy/MM/dd",
                placeholder: "请选择关闭日期",
                value: closeDate,
              },
              on: {
                change(newValue) {
                  closeDate = newValue;
                },
              },
            }),
          ]),
        ]),
      })
        .then(() => {
          closeDate = closeDate || this.$moment().toDate();
          closeDate = this.$moment(closeDate).format("YYYY/MM/DD");
          this.closeSAWorkflowServiceByIdToServer(closeDate);
        })
        .catch(() => {});
    },

    // serviceItemList 相关方法
    onServiceItemListChange(needReload) {
      if (needReload) this.loadSAStudentWorkflowServiceFromServer();
      else this.resetWorkflowServiceByServiceItems();
    },
  },
  watch: {
    workflowService(newValue) {
      this.resetWorkflowServiceInfoDataIn();
    },
  },
};
</script>

<style lang="scss" scoped>
.workflowService-container {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  vertical-align: bottom;

  .el-button {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/studyAbroad/studentServiceDetail.vue